import { ComponentPropsWithoutRef } from 'react'

import { cn } from '@/utils/tw-helpers'

interface Props extends ComponentPropsWithoutRef<'div'> {
  children: React.ReactNode
}

export const WebPanel = ({
  children,
  className,
  ...rest
}: Props): JSX.Element => {
  return (
    <div
      className={cn(
        'flex flex-col rounded-xl bg-white',
        'md:px-5 lg:px-[38px]',
        className
      )}
      {...rest}
    >
      {children}
    </div>
  )
}

export const WebPanelItem = ({
  children,
  className,
  ...rest
}: Props): JSX.Element => {
  return (
    <div
      className={cn(
        'flex min-h-[86px] w-full items-center border-b border-outline px-3 md:min-h-[90px] md:px-0',
        'last:border-none',
        className
      )}
      {...rest}
    >
      {children}
    </div>
  )
}

export const WebPanelItemLabel = ({
  children,
  className,
  ...rest
}: Props): JSX.Element => {
  return (
    <span
      className={cn(
        'w-[94px] shrink-0 text-[15px] text-xs font-bold',
        'md:w-[130px] md:text-sm lg:w-[167px] lg:text-[15px]',
        className
      )}
      {...rest}
    >
      {children}
    </span>
  )
}

export const WebPanelItemContent = ({
  children,
  className,
  ...rest
}: Props): JSX.Element => {
  return (
    <div className={cn('text-secondary-93', className)} {...rest}>
      {children}
    </div>
  )
}

export const WebPanelItemAction = ({
  children,
  className,
  ...rest
}: Props): JSX.Element => {
  return (
    <div className={cn('ml-auto shrink-0', className)} {...rest}>
      {children}
    </div>
  )
}
